<template>
<div class="activityTemp">
    <keep-alive :include="includeList">
        <router-view v-if="user.providerstatus == 10"></router-view>
    </keep-alive>
    <serviceProviderTip  v-if="user.providerstatus != 10"></serviceProviderTip>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import ServiceProviderTip from 'views/serviceProvider/components/serviceProviderTip.vue'
export default {
    name: 'activityTemp',
    data() {
        return {
            noPower: require('@/common/images/creativeAccount/noPower.png'),
            includeList: ['ActivityTempList', 'ActivityTempGoodsList']
        }
    },
    mounted() {
    },
    methods: {
        handleAdd() {
            this.openServiceProviderEditDialog()
        },
        openServiceProviderEditDialog() {
            this.$refs.serviceProviderEditDialog.openDialog('add')
        },
        ...mapActions(['setParams'])
    },
    filters: {

    },
    watch: {},
    computed: {
        ...mapGetters(['user', 'params', 'shop'])
    },
    components: {
        ServiceProviderTip
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.activityTemp{
}
</style>
